module.exports = __webpack_public_path__ + "static/media/icon-zip.20aeb728.svg";